import OverlayTips from "../../OverlayTips";

function LeaveTimeBalancesPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
    this._refreshDynamicTipsDeferred = true;
}

LeaveTimeBalancesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);
        
        this.add($("#pastLeavesCalendarTab"), {
            messageKey: "actiplans.reports.leave_time.tips.past_leaves_calendar_tab",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -75,
            offsetY: 15
        });

        this.add($("#balanceHistoryTab").not(".disabled"), {
            messageKey: "actiplans.reports.leave_time.tips.balance_history_tab",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -20,
            offsetY: 5
        });

        this.add($("#leaveTimeAndBalancesChartSectionContainer").find('.collapseButton'), {
            messageKey: "actiplans.reports.leave_time.tips.chart_button",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: -5
        });

        this.add($("#leaveTimeEditConfigSelector"), {
            messageKey: "actiplans.reports.tips.edit_config_button",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -100,
            offsetY: 15
        });

        this.add($("#leaveTimeExportSelector"), {
            messageKey: "actiplans.reports.tips.export",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -40,
            offsetY: 15
        });
    }
});

export default LeaveTimeBalancesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/reports/LeaveTimeBalancesPageOverlayTipsManager.js